export default {"src":"/_next/static/media/flame.265ed060.svg","height":27,"width":27};